import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEmpty } from 'lodash';

import SignInScreen from './SignInScreen';
import {
    accountStatusCheck as accountStatusCheckAction,
    logInUser as logInUserAction,
    signUpUser as signUpUserAction,
    socialLogInUser as socialLogInUserAction,
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    socialSignUpUser as socialSignUpUserAction,
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    clearAuthNotification as clearAuthNotificationAction,
    forceStld as forceStldAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
    trackGetStartedClick as trackGetStartedClickAction,
    trackTermsOfServiceClick as trackTermsOfServiceClickAction,
    trackComunityGuidelinesClick as trackComunityGuidelinesClickAction,
    trackEmailMismatchAction,
    trackPrivacyPolicyClick as trackPrivacyPolicyClickAction,
    trackEmailConfirmationInput as trackEmailConfirmationAction,
    trackLoginInsteadClick as trackLoginInsteadAction,
} from '../../actions/auth';

const _mapStateToProps = ({ authentication, form }) => ({
    form,
    email: authentication.email,
    socialData: authentication.socialData,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: authentication.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
    shouldRenderAuthNotification: !isEmpty(
        authentication.authNotificationOptions,
    ),
    authTypeSetting: authentication.authTypeSetting,
    stld: authentication.stld,
    shouldIncludeEmailConfirmation:
        authentication.shouldIncludeEmailConfirmation,
    showCreatorEncouragement: authentication.showCreatorEncouragement,
    disableRecaptcha3: authentication.disableRecaptcha3,
    referrer: authentication.referrer,
    shouldShowAUSignUp: authentication.shouldShowAUSignUp,
});

const _mapDispatchToProps = {
    onAccountStatusCheck: accountStatusCheckAction,
    onLogInUser: logInUserAction,
    onSignUpUser: signUpUserAction,
    onSocialLogInUser: socialLogInUserAction,
    onSocialLogInUserNotAuthorized: socialLogInUserNotAuthorizedAction,
    onSocialSignUpUser: socialSignUpUserAction,
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
    moveBack: moveBackAction,
    onLinkedAccountsCreatePassword: sendResetPasswordEmailAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    clearAuthNotification: clearAuthNotificationAction,
    onForceStld: forceStldAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    onGetStartedClick: trackGetStartedClickAction,
    onTermsOfServiceClick: trackTermsOfServiceClickAction,
    onComunityGuidelinesClick: trackComunityGuidelinesClickAction,
    onPrivacyPolicyClick: trackPrivacyPolicyClickAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    onLoginInsteadClick: trackLoginInsteadAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SignInScreen),
);
